<core-generic-table [dataInput]="bookings()" [endpoint]="endpoint" [listTitle]="'bookings.title' | translate"
  [columns]="columns" [modalFields]="modalFields()" [actions]="actions"
  [globalActions]="globalActions"
  [showFilter]="true" [showSelection]="false" [showActions]="true" [showCreateButton]="true" [enablePagination]="true"
  [showActiveFilters]="true" [modelFactory]="bookingModelFactory" [customActions]="customActions" [moreData]="moreData"
  [sortConfig]="sortConfig()" [customFilters]="customFilters()" [scrollTable]="true" [onApiError]="onApiError"
  (formReady)="onBookingFormReady($event)"
  (onMoreDataLoaded)="onMoreDataLoaded($event)" (onFilterChange)="onFilterChange($event)"
  (onClearFilters)="onFilterChange()" (beforeSave)="onBeforeSave($event)" class="o-layout__section" />

<ng-template #originPortFieldTemplate let-value="value" let-data="data" let-mode="mode" let-errors="errors"
  let-formValue="formValue">
  <div class="bookings-port-field">
    <span class="c-entry-text bookings-port-field__label">
      {{ getBookingFieldLabel('originPort', data) | translate }}
      @if (bookingFieldIsRequired('originPort', data)) {
        <span class="c-required">*</span>
      }
    </span>
    <div class="bookings-port-field__row">
      <div class="bookings-port-field__input" coreDynamicField [field]="getBookingPortInputField('originPort', mode)"
        [value]="value" [mode]="mode" [errors]="resolveBookingFieldErrors('originPort', errors)" [rowData]="data"
        [formValue]="formValue" (valueChange)="syncBookingField('originPort', data, $event, true)"
        (onBlurEvent)="markBookingFieldTouched('originPort')">
      </div>
      <core-generic-button class="bookings-port-field__action" [config]="refreshPortsButtonConfig()"
        (buttonClick)="refreshPorts()">
      </core-generic-button>
    </div>
  </div>
</ng-template>

<ng-template #destinationPortFieldTemplate let-value="value" let-data="data" let-mode="mode" let-errors="errors"
  let-formValue="formValue">
  <div class="bookings-port-field">
    <span class="c-entry-text bookings-port-field__label">
      {{ getBookingFieldLabel('destinationPort', data) | translate }}
      @if (bookingFieldIsRequired('destinationPort', data)) {
        <span class="c-required">*</span>
      }
    </span>
    <div class="bookings-port-field__row">
      <div class="bookings-port-field__input" coreDynamicField
        [field]="getBookingPortInputField('destinationPort', mode)" [value]="value" [mode]="mode"
        [errors]="resolveBookingFieldErrors('destinationPort', errors)" [rowData]="data" [formValue]="formValue"
        (valueChange)="syncBookingField('destinationPort', data, $event, true)"
        (onBlurEvent)="markBookingFieldTouched('destinationPort')">
      </div>
      <core-generic-button class="bookings-port-field__action" [config]="refreshPortsButtonConfig()"
        (buttonClick)="refreshPorts()">
      </core-generic-button>
    </div>
  </div>
</ng-template>

<ng-template #transshipmentPortFieldTemplate let-value="value" let-data="data" let-mode="mode" let-errors="errors"
  let-formValue="formValue">
  <div class="bookings-port-field">
    <span class="c-entry-text bookings-port-field__label">
      {{ getBookingFieldLabel('transshipmentPort', data) | translate }}
      @if (bookingFieldIsRequired('transshipmentPort', data)) {
        <span class="c-required">*</span>
      }
    </span>
    <div class="bookings-port-field__row">
      <div class="bookings-port-field__input" coreDynamicField
        [field]="getBookingPortInputField('transshipmentPort', mode)" [value]="value" [mode]="mode"
        [errors]="resolveBookingFieldErrors('transshipmentPort', errors)" [rowData]="data" [formValue]="formValue"
        (valueChange)="syncBookingField('transshipmentPort', data, $event, true)"
        (onBlurEvent)="markBookingFieldTouched('transshipmentPort')">
      </div>
      <core-generic-button class="bookings-port-field__action" [config]="refreshPortsButtonConfig()"
        (buttonClick)="refreshPorts()">
      </core-generic-button>
    </div>
  </div>
</ng-template>

<ng-template #statusTemplate let-row let-column="column">
  <span class="c-tag">{{row.status | titlecase}}</span>
</ng-template>

@if(activeBookingForUploadAttachments() !== null){
<app-booking-attachments-modal [booking]="activeBookingForUploadAttachments()!"
  (onClose)="onCloseBookingAttachments()" />
}

<app-booking-import-modal [isOpen]="showImportModal()" (closed)="onImportModalClosed()"
  (imported)="onBookingsImported()" />

<ng-template #clientTemplate let-row let-column="column">
  <span class="bookings-client-cell" [title]="clientName(row.client)">
    {{ clientShortName(row.client) }}
  </span>
</ng-template>

<ng-template #voyageTemplate let-row let-column="column">
  @if(row.requiresTransshipment) {
  <span>
    {{ 'bookingsView.leg1' | translate }}: {{ formatLeg(row.voyageDetails) }} /
    {{ 'bookingsView.leg2' | translate }}:
    @if(row.secondVoyage === 'TBN') {
    <span>TBN</span>
    } @else {
    {{ formatLeg(row.secondVoyageDetails) }}
    }
  </span>
  } @else {
  <span>{{ voyageName(row.voyageDetails) }}</span>
  }
</ng-template>
